import { useState } from "preact/hooks";
import { Form } from "../form/Form";
import { sendForm } from "../../services/ApplicationService";

export const STATUSES = {
    ERROR: "ERROR",
    SUCCESS: "SUCCESS"
  }

export const FormContainer = () => {
    const [status, changeStatus] = useState(null);
    const [isLoading, setLoading] = useState(false)

    const onSubmit = async (evt) => {
      evt.preventDefault();

      setLoading(true)

      const error = await sendForm({ email: evt.target.email.value })

      setLoading(false)
      
      if (!error) {
        changeStatus(STATUSES.SUCCESS);
        return;
      }

      changeStatus(STATUSES.ERROR);

   

    }

    return <Form onSubmit={onSubmit} isLoading={isLoading} status={status} />
}